import { SIGNUP_STEPS } from "./signup.constants.ts";

/**
 * The 1–2–3 marker row.
 *
 * `complete` is separate from `current` because the last panel is neither
 * before nor after the final step — it is that step, finished, so every marker
 * shows a tick and none is highlighted as pending.
 */
export function SignupSteps({
  current,
  complete,
}: {
  current: number;
  complete: boolean;
}) {
  return (
    <ol className="signup__steps">
      {SIGNUP_STEPS.map((step, index) => {
        const done = complete || index < current;
        const active = !complete && index === current;

        return (
          <li className="signup__step" key={step.key}>
            <span
              className={`signup__step-marker${
                done ? " signup__step-marker--done" : ""
              }${active ? " signup__step-marker--active" : ""}`}
              aria-hidden="true"
            >
              {done ? "✓" : index + 1}
            </span>
            <span
              className={`signup__step-label${
                active ? " signup__step-label--active" : ""
              }`}
            >
              {step.label}
            </span>
            {done && <span className="signup__step-state"> (complete)</span>}
            {index < SIGNUP_STEPS.length - 1 && (
              <span
                className={`signup__step-rule${
                  done ? " signup__step-rule--done" : ""
                }`}
                aria-hidden="true"
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
